import './BidGallery.css'; 
import { API_BASE_URL } from '../utils';


const BidGallery = ({ gallery }) => {

    const url = `${API_BASE_URL}/master/assets/uploads/`;


    return (
        <div className="gallery-container">
            <h3 className="gallery-category-title">{gallery.category}</h3>
            {gallery.images.map((imgObj, imgIndex) => (
                <div key={imgIndex} className="gallery-image-wrapper">
                    <img
                        src={url + imgObj.img}
                        alt={`Gallery ${gallery.category} ${imgIndex + 1}`}
                        className="gallery-image"
                    />
                </div>
            ))}
        </div >
    );
};

export default BidGallery;
